<template>
    <div class="flex flex-col lg:flex-row justify-between items-stretch gap-4 mb-8">

        <div class="w-full lg:w-1/4">
            <v-card class="px-2 py-2">
                <v-card-subtitle class="text-base uppercase font-bold text-gray-500 py-2">
                    Detalii client
                </v-card-subtitle>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="font-bold">{{ oferta.nume }}</v-list-item-title>
                        <v-list-item-subtitle v-if="oferta.cui || oferta.reg_com">{{ `${oferta.cui} | ${oferta.reg_com}`
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="oferta.adresa">
                            {{ oferta.adresa }}
                            <span v-if="oferta.oras">
                                {{ oferta.oras }}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-subtitle v-if="oferta.persoana" class="mt-2">
                            <span>Reprezentant: </span>
                            <span class="font-bold">{{ oferta.persoana }}</span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="oferta.tel">{{ oferta.tel }}</v-list-item-subtitle>
                        <v-list-item-subtitle v-if="oferta.email">{{ oferta.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-card>
        </div>

        <div class="w-full lg:w-1/2">
            <v-card class="px-2 py-2">
                <v-card-subtitle class="text-base uppercase font-bold text-gray-500 py-2">
                    Detalii lucrare
                </v-card-subtitle>
                <div class="px-4">
                    <div class="flex justify-start gap-4">
                        <div v-if="oferta.country != 'ro'" class="flex items-center">
                            Țară:
                            <span class="text-2xl px-2">
                                {{ displayFlag(oferta.country) }}
                            </span>
                        </div>
                        <div class="flex flex-row justify-start gap-2 items-center py-2">
                            <span class="font-bold">{{
                                `${oferta.country
                                    == 'ro' ? 'Judet:' : 'Regiune:'} ` }}{{ oferta.county_name | NoData }}</span>
                            <v-dialog v-model="visibleCountyModal" max-width="300px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn text color="teal" class="uppercase" v-bind="attrs" v-on="on">Modifica</v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="">Schimba {{ oferta == 'ro' ? 'judetul' : 'regiunea'
                                            }}
                                            ofertei</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <ChangeCounty :offer-id="oferta.id_oferta" :country="oferta.country"
                                            :currentCounty="oferta.county_name"
                                            @closeModal="visibleCountyModal = false" />
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </div>
                    </div>
                </div>

                <div class="flex justify-start items-center gap-2 px-4">
                    <span class="flex-grow-0">
                        Denumire lucrare:
                    </span>
                    <div class="flex-grow">
                        <div v-if="visibleEditName" class="flex justify-start items-center gap-2">
                            <v-text-field v-model="oferta.denumire_lucrare" class="w-full" dense outlined hide-details>
                            </v-text-field>
                            <v-btn color="teal" class="uppercase" text @click="saveName">Salvează</v-btn>
                        </div>
                        <div v-else class="flex justify-start items-center gap-4">
                            <span class="font-bold">{{ oferta.denumire_lucrare }}</span>
                            <v-btn v-if="!readOnly && !oferta.id_contract" color="teal" class="uppercase" text
                                @click="visibleEditName = true">Modifica</v-btn>
                        </div>
                    </div>
                </div>

                <div class="flex justify-start items-center gap-2 px-4">
                    <span class="flex-grow-0">
                        Culoare gard:
                    </span>
                    <div>
                        <div v-if="visibleEditColor" class="flex justify-start items-center gap-2">
                            <v-select v-model="oferta.color" class="w-52" :items="selectColorList" item-text="ral"
                                item-value="ral" dense outlined hide-details>
                                <template v-slot:item="{ item }">
                                    <div class="flex items-center gap-2">
                                        <span v-if="item.hex" style="width: 50px; height: 20px"
                                            :style="'background-color: ' + item.hex">
                                        </span>
                                        <span class="text-base font-bold">
                                            {{ item.ral }}
                                        </span>
                                    </div>
                                </template>
                                <template v-slot:selection="{ item }">
                                    <div class="flex items-center gap-2">
                                        <span v-if="item.hex" style="width: 50px; height: 20px"
                                            :style="'background-color: ' + item.hex">
                                        </span>
                                        <span class="text-base font-bold">
                                            {{ item.ral }}
                                        </span>
                                    </div>
                                </template>
                            </v-select>
                            <v-btn color="teal" class="uppercase" text @click="saveColor">Salvează</v-btn>
                        </div>
                        <div v-else class="flex justify-start items-center gap-4">
                            <div class="flex items-center gap-2 px-3 py-2">
                                <span v-if="oferta.color != 'client nehotarat'" style="width: 50px; height: 20px"
                                    :style="'background-color: ' + currentColor">
                                </span>
                                <span class="font-bold">
                                    {{ oferta.color }}
                                </span>
                            </div>
                            <v-btn v-if="!readOnly && !oferta.id_contract" color="teal" class="uppercase" text
                                @click="visibleEditColor = true">Modifica</v-btn>
                        </div>
                    </div>
                </div>

                <div class="flex gap-12 px-4">
                    <div v-if="oferta.tip_lucrare" class="w-full lg:w-1/2 flex justify-between items-center gap-8 py-4">
                        <div>
                            <div class="flex justify-between items-center gap-2">
                                <span>Valoare fara TVA:</span>
                                <div class="flex items-center">
                                    <span v-if="eurCurrency">{{ totalNetEur }} EUR</span>
                                    <span v-else>{{ totalNet }} {{ monedaLabel }}</span>
                                </div>
                            </div>

                            <div class="flex justify-between items-center gap-2 font-bold">
                                <span>Valoare cu TVA:</span>
                                <div class="flex items-center">
                                    <span v-if="eurCurrency">{{ totalEur }} EUR</span>
                                    <span v-else>{{ total }} {{ monedaLabel }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- which currency the figures are in; the highlighted side is the one shown -->
                        <v-btn text small color="teal" class="flex-grow-0 px-2" title="Schimba moneda afisata"
                            @click="eurCurrency = !eurCurrency">
                            <span :class="eurCurrency ? 'text-gray-400' : 'font-bold'">{{ monedaLabel }}</span>
                            <v-icon small class="mx-1">mdi-swap-horizontal</v-icon>
                            <span :class="eurCurrency ? 'font-bold' : 'text-gray-400'">EUR</span>
                        </v-btn>
                    </div>
                    <div v-if="oferta.tip_lucrare == 'gard'" class="w-full lg:w-1/2">
                        <div class="flex justify-between items-center gap-2">
                            <span>Suprafata panouri:</span>
                            <div class="flex items-center">
                                <span>{{ suprafataPanouri.toFixed(2) }} m²</span>
                            </div>
                        </div>
                        <div class="flex justify-between items-center gap-2">
                            <span>Suprafata porti:</span>
                            <div class="flex items-center">
                                <span>{{ suprafataPorti.toFixed(2) }} m²</span>
                            </div>
                        </div>
                        <div class="flex justify-between items-center gap-2 font-bold">
                            <span>Suprafata totala:</span>
                            <div class="flex items-center">
                                <span>{{ suprafataTotala.toFixed(2) }} m²</span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>

        <div class="w-full lg:w-1/4">
            <v-card class="px-2 py-2">
                <v-card-subtitle class="text-base uppercase font-bold text-gray-500 py-2">
                    Detalii ofertă
                </v-card-subtitle>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-subtitle>
                            <span>Dată ofertă:</span>
                            <span class="font-bold">
                                {{ oferta.data | formatDate }}
                            </span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                            <span>Întocmit de:</span>
                            <span class="font-bold">
                                {{ oferta.username }}
                            </span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <div class="my-2">
                    <v-btn v-if="oferta.id_contract" :to="'/productie/contracte/single/' + oferta.id_contract" text
                        class="uppercase" :disabled="readOnly">
                        Contract nr. {{ oferta.id_contract }}
                        <v-icon color="primary">mdi-arrow-right-thin</v-icon>
                    </v-btn>
                </div>
            </v-card>
        </div>

    </div>
</template>

<script>
import flags from "@/assets/countries-flags.json"
import ral_colors from "@/assets/ral_colors.json"
import ChangeCounty from "@/components/Productie/Garduri/ChangeCounty.vue"

export default {
    components: {
        ChangeCounty
    },
    props: {
        oferta: Object,
        readOnly: Boolean,
        moneda: String,
        cost: String,
        costEur: String,
        // the offer's own value, before VAT - the line above the with-VAT one
        totalNet: String,
        totalNetEur: String,
        total: String,
        totalEur: String,
        suprafataPanouri: Number,
        suprafataPorti: Number,
        suprafataTotala: Number
    },
    data() {
        return {
            visibleCountyModal: false,
            visibleEditName: false,
            visibleEditColor: false,
            eurCurrency: true,
            ralColors: ral_colors,
        }
    },
    computed: {
        /** The offer's own currency, spelled the way it is shown. */
        monedaLabel() {
            return String(this.moneda || "ron").toUpperCase();
        },
        currentColor() {
            let colorName = this.oferta.color;
            if (colorName == "client nehotarat") {
                return;
            } else {
                const color = this.ralColors.find((item) => {
                    return item.ral == colorName;
                });
                if (color) {
                    return color.hex;
                } else {
                    return '#ffffff'
                }
            }
        },
        selectColorList() {
            return [{ ral: 'client nehotarat' }, ...this.ralColors]
        }
    },
    watch: {
        "oferta.tip_lucrare"(newVal) {
            if (newVal == "gard") {
                this.eurCurrency = true;
            } else {
                this.eurCurrency = false;
            }
        },
    },
    methods: {
        displayFlag(country) {
            if (country && country != 'ro') {
                const flagCountry = flags[country.toUpperCase()]
                return flagCountry.emoji
            } else {
                return
            }

        },
        saveName() {
            let newName = {
                denumire: this.oferta.denumire_lucrare,
            };
            let id = this.$route.params.id;
            this.$store.dispatch("changeNameOfertaProductie", {
                object: newName,
                id: id,
            });
            this.visibleEditName = false;
        },
        saveColor() {
            let id = this.$route.params.id;
            this.$store.dispatch("changeColorOfertaProductie", {
                color: this.oferta.color,
                id: id,
            });
            this.visibleEditColor = false;
        },
    }
}
</script>

<style scoped>
.v-list-item__subtitle {
    @apply text-base
}
</style>